import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IMedicationSettings } from '@interfaces/medications';
import { handleGetMedicationSettings } from '@store/features/medicationSettings/actions';
import {
  medicationSettingsErrorSelector,
  medicationSettingsIsLoadingSelector,
  medicationSettingsIsReadySelector,
  medicationSettingsSelector,
} from '@store/features/medicationSettings/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useMedicationSettings = (): IMedicationSettings | null => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(medicationSettingsSelector);
  const isLoading = useSelector(medicationSettingsIsLoadingSelector);
  const isReady = useSelector(medicationSettingsIsReadySelector);
  const error = useSelector(medicationSettingsErrorSelector);

  const handleFetch = useCallback(() => {
    dispatch(handleGetMedicationSettings());
  }, [dispatch]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.medicationSettingsError'),
    handleFetch,
  });

  return data;
};

export default singletonHook(null, useMedicationSettings);
